import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=cb3f8408&scoped=true"
import script from "./nav.vue?vue&type=script&lang=ts"
export * from "./nav.vue?vue&type=script&lang=ts"
import style0 from "./nav.vue?vue&type=style&index=0&id=cb3f8408&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3f8408",
  null
  
)

export default component.exports